// extracted by mini-css-extract-plugin
export default {"description":"LineGraphCard_description__0xTZq"};